import React from 'react'
import Space from '../atoms/Space'
import NewSidebar from './NewSidebar'
import NewToolbar from '../atoms/NewToolbar'
interface ToolbarProps {
  name: string
  iconComponent: JSX.Element
  withFiler: boolean
}

interface BaseProps {
  children: JSX.Element
}

interface WithoutToolbarProps extends BaseProps {
  withoutToolbar: true
}

interface WithToolbarProps extends BaseProps, ToolbarProps {
  withoutToolbar?: false
}

type LayoutProps = WithoutToolbarProps | WithToolbarProps

const Layout = (props: LayoutProps): JSX.Element => {
  const withoutToolbar = typeof props.withoutToolbar !== 'undefined' && props.withoutToolbar
  return (
    <div className="p-10 fonts overflow-hidden">
      <div className="max-w-[1920px] mx-auto">
        <div className="flex">
          {/* <Sidebar /> */}
          <NewSidebar />
          <div className="w-10" />
          <div className="w-full relative">
            {!withoutToolbar && (
              <>
                {/* <Toolbar name={props.name} iconComponent={props.iconComponent} withFiler={props.withFiler} /> */}
                <NewToolbar name={props.name} withFiler={props.withFiler} />

                <Space y={1} />
              </>
            )}
            {props.children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Layout
